import React from 'react';
import { Typography } from '@material-ui/core';

function Paragraph({ paragraph }) {
  // console.log('paragraph ', paragraph);
  const para = paragraph.verse
    .map(currentVerse => (
      <span key={currentVerse && currentVerse.id}>
        {currentVerse.startVerse ? <sup>{currentVerse.verseNum}</sup> : <sup />} {currentVerse.text}
      </span>
    ))
    .reduce((result, current) => [result, ' ', current], []);
  // console.log("para result", para);
  return (
    <div>
      <Typography variant="h4" key={paragraph && paragraph.id.concat('subtitlen')}>
        {paragraph && paragraph.subtitle ? capitalizeFirstLetter(paragraph.subtitle) : ''}
      </Typography>
      <p />
      <div>
        <Typography
          variant="h6"
          key={paragraph && paragraph.id}
          align="justify"
          // paragraph={false}
          color="textPrimary"
        >
          {para}
          <p />
        </Typography>
      </div>
    </div>
  );
}
function isChar(char){
  if(char){
  return !/[\-\\']/g.test(char);
  }else {
    return false;
  }
}
function capitalizeFirstLetter(sentence) {
  const words = sentence.split(' ');

  for (let i = 0; i < words.length; i++) {
    if(isChar(words[i][0])){
    words[i] = words[i][0].toUpperCase() + words[i].substr(1);
    }
  }

  return words.join(' ');
}
export default Paragraph;
